module.exports = __webpack_public_path__ + "53aa7ef162612dd01cc4706e876808d1.png";